import type {AuthenticationSystemId} from 'shared/login/kp-login/types';
import type {SvelteComponentConstructor} from 'core/types';
import BankidLoginSystem from 'shared/login/kp-login/login-systems/bankid/BankidLoginSystem.svelte';
import CasLoginSystem from 'shared/login/kp-login/login-systems/cas/CasLoginSystem.svelte';
import GoogleLoginSystem from 'shared/login/kp-login/login-systems/google/GoogleLoginSystem.svelte';
import InternalLoginSystem from 'shared/login/kp-login/login-systems/internal/InternalLoginSystem.svelte';
import LdapLoginSystem from 'shared/login/kp-login/login-systems/ldap/LdapLoginSystem.svelte';
import LoginTicketLoginSystem from 'shared/login/kp-login/login-systems/loginticket/LoginTicketLoginSystem.svelte';
import MojeidLoginSystem from 'shared/login/kp-login/login-systems/mojeid/MojeidLoginSystem.svelte';
import Saml2LoginSystem from 'shared/login/kp-login/login-systems/saml2/Saml2LoginSystem.svelte';

export const LoginSystemIdToComponentMap: Record<AuthenticationSystemId, SvelteComponentConstructor> = {
    bankid: BankidLoginSystem,
    cas: CasLoginSystem,
    google: GoogleLoginSystem,
    internal: InternalLoginSystem,
    ldap: LdapLoginSystem,
    loginticket: LoginTicketLoginSystem,
    mojeid: MojeidLoginSystem,
    saml2: Saml2LoginSystem
};